import _ from 'lodash'

/**
 * Displays or hides a specified `.alert-bubble` element based on whether the passed
 * in count is a valid number greater than 0
 *
 * @param context the Backbone View to find the element in
 * @param selector the class selector for the specific bubble to render
 * @param count the count to display in the bubble
 */
export default function(context, selector, count) {
	if (!count || !_.isFinite(count) || count <= 0) {
		context.$('.alert-bubble' + selector).hide().empty()
	} else {
		context.$('.alert-bubble' + selector).show().text(count)
	}
}